export const timelineStages = [
  {
    stage: '01',
    title: '重逢',
    time: '故事开端',
    desc: '多年未见的老同学重新聚到一起，旧日的暗恋与遗憾被重新点亮，为后续所有关系线埋下引线。',
    icon: 'ri-restart-line',
  },
  {
    stage: '02',
    title: '试探',
    time: '第一天 · 白天',
    desc: '客气而克制的寒暄之下，每个人都在偷偷打量彼此这些年的变化，也在评估重新靠近的成本。',
    icon: 'ri-question-line',
  },
  {
    stage: '03',
    title: '越界',
    time: '第一天 · 深夜',
    desc: '酒桌与独处让关系边界迅速模糊，情感越界发生，几个家庭在同一时间出现裂缝。',
    icon: 'ri-links-line',
  },
  {
    stage: '04',
    title: '算计',
    time: '系列第二部',
    desc: '故事重心从情感转向金钱，有人以理财投资为名重新靠近老同学，信任被当成杠杆使用。',
    icon: 'ri-money-cny-circle-line',
  },
  {
    stage: '05',
    title: '反噬',
    time: '系列后段',
    desc: '骗局与秘密同时逼近暴露，一次追问、一个电话，就足以让原本稳固的关系链开始松动。',
    icon: 'ri-alarm-warning-line',
  },
  {
    stage: '06',
    title: '收束',
    time: '结局',
    desc: '每个人为选择付出代价，关系网被重新洗牌。没有人是纯粹的赢家，也没有轻松的收尾。',
    icon: 'ri-scales-3-line',
  },
];

export const turningPoints = [
  {
    title: '那一场不愿散场的酒',
    desc: '聚会从社交变成坦白，是整条故事线真正开始下滑的原点。',
    icon: 'ri-goblet-line',
  },
  {
    title: '一次转账',
    desc: '当感情问题被换算成金钱，“信任”就从纽带变成了最锋利的工具。',
    icon: 'ri-exchange-dollar-line',
  },
  {
    title: '一个被忽略的细节',
    desc: '沉默者对细节的留意，往往在后段成为秘密暴露的引子。',
    icon: 'ri-search-eye-line',
  },
  {
    title: '最后一场同学会',
    desc: '看似回到原点的聚会，其实是所有人不得不面对后果的时刻。',
    icon: 'ri-group-2-line',
  },
];